import {
  AIcon,
  BoltIcon,
  CaseIcon,
  ChartPieIcon,
  ChatIcon,
  CommunityIcon,
  DocumentIcon,
  FamilyIcon,
  FileIcon,
  HouseIcon,
  LightbulbIcon,
  SettingsIcon,
  ShieldStrokeIcon,
  Vehicle5Icon,
  VolumeIcon,
} from "@/shared/icons";
import { BaseIcon } from "@/shared/icons/BaseIcon";
import { SubHeaderTab } from "@/domains/playerMenu/constants/subHeaderTab";

export const subHeaderIcon: Record<SubHeaderTab, typeof BaseIcon> = {
  [SubHeaderTab.Data]: FileIcon,
  [SubHeaderTab.Documents]: DocumentIcon,
  [SubHeaderTab.Estate]: HouseIcon,
  [SubHeaderTab.Vehicle]: Vehicle5Icon,
  [SubHeaderTab.Family]: FamilyIcon,
  [SubHeaderTab.Faction]: CommunityIcon,
  [SubHeaderTab.Business]: CaseIcon,
  [SubHeaderTab.Skills]: LightbulbIcon,
  [SubHeaderTab.Statistic]: ChartPieIcon,
  [SubHeaderTab.Basic]: SettingsIcon,
  [SubHeaderTab.Sound]: VolumeIcon,
  [SubHeaderTab.Control]: AIcon,
  [SubHeaderTab.Safety]: ShieldStrokeIcon,
  [SubHeaderTab.Gameplay]: BoltIcon,
  [SubHeaderTab.Chat]: ChatIcon,
};
